export default __webpack_public_path__ + "static/flipImg1-0d4340b3b3206164d43ed18637df5d8b.webp";